import ajax from '@/libs/api.request'

export default {
    getPermissionList: param => {
        return ajax.get('/web/perm/getAllPermission', param)
    }
}

